import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PullstateProvider } from 'pullstate';

import { PageLayout } from '@/renderer/PageLayout';
import { PullstateCore } from '@/renderer/store';
import { IdleContextProvider } from '@/renderer/utils/useIdle';

// children includes <Page/>
export function Wrapper({ children }: { children: React.ReactNode }) {
  const pullstate = PullstateCore.instantiate({ ssr: true });

  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <PullstateProvider instance={pullstate}>
        <IdleContextProvider>
          <PageLayout>{children}</PageLayout>
        </IdleContextProvider>
      </PullstateProvider>
    </QueryClientProvider>
  );
}
